import _split from 'lodash/split';

export default (value: string | null | undefined): string[] | null => {
  let options: string[] = [];
  if (value && value.length) {
    const optionsSplit = _split(value, '\n');
    optionsSplit.forEach(option => {
      const optionsCommaSplit = _split(option, ',');
      optionsCommaSplit.forEach(splitCommaOption => {
        const optionSpaceSplit = splitCommaOption.trim();
        if (optionSpaceSplit.length) {
          options.push(optionSpaceSplit);
        }
      });
    });
    options.map(option => {
      option.split(' ').join('');
      option.split(',').join('');
      option.split('\n').join('');
      return option;
    });
    return options;
  }
  return null;
};
